import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  size?: 'default' | 'large';
  onClick?: () => void;
}
export function CTAButton({
  children,
  className = '',
  size = 'default',
  onClick
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'px-10 py-5 text-xl' : 'px-8 py-4 text-lg';
  return <button onClick={onClick} className={`
        bg-gradient-to-r from-blue-600 to-cyan-500 
        text-white font-bold rounded-lg 
        transition-all duration-300 
        hover:scale-105 hover:shadow-2xl
        btn-glow
        flex items-center justify-center gap-3
        ${sizeClasses}
        ${className}
      `} aria-label={typeof children === 'string' ? children : 'Comprar ahora'} data-id="element-8">
      {children}
      <ArrowRightIcon className="h-6 w-6" aria-hidden="true" data-id="element-9" />
    </button>;
}